import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import CreateEditRole from "./CreateEditRole.js";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

const RolesList = (props) => {
  const { t } = useTranslation();
  let roles = props.data;
  let rolesAndRightsUI = props.dataUI;
  let link = localStorage.getItem("link");
  let activeRights = JSON.parse(localStorage.getItem("rights"));
  let canCreate = activeRights.includes("Roles.Create");
  let canEdit = activeRights.includes("Roles.Update");
  let canDel = activeRights.includes("Roles.Delete");

  const [popUpShow, setPopUpShow] = useState(false);
  const [currentRoleData, setCurrentRoleData] = useState();

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
  }, [localStorage.getItem("JWT")]);

  function editCreateRole(roleData) {
    setCurrentRoleData(roleData);
    setPopUpShow(true);
  }

  const deleteRole = (roleData) => {
    let id = roleData.roleID;

    confirmAlert({
      message: t("allgemein.bestaetigen"),
      buttons: [
        {
          label: t("allgemein.ja"),
          onClick: () =>
            axios
              .delete(link + "/api/RolesAndRights?roleID=" + id)
              .then((response) => {
                props.onChange();
              })

              .catch((error) => {}),
        },
        {
          label: t("allgemein.nein"),
        },
      ],
    });
  };

  function rolesList() {
    let rolesList = [];

    for (let i = 0; i < roles.length; i++) {
      rolesList.push(
        <tr key={"key_" + i}>
          <td>{roles[i].roleName}</td>
          <td>
            {canEdit && (
              <i
                className="bx bx-edit bx-sm"
                style={{ marginLeft: "10px" }}
                onClick={() => editCreateRole(roles[i])}
                title={t("allgemein.Bearbeiten")}
              ></i>
            )}
            {!roles[i].isPersistent && canDel && !roles[i].assignedToUsers && (
              <i
                className="bx bx-trash bx-sm"
                style={{ marginLeft: "10px" }}
                onClick={() => deleteRole(roles[i])}
                title={t("allgemein.Loeschen")}
              ></i>
            )}
          </td>
        </tr>
      );
    }

    return <tbody>{rolesList}</tbody>;
  }

  function popUpChange() {
    props.onChange();
    setPopUpShow(false);
  }

  return (
    <>
      {popUpShow == true && (
        <div style={{ width: "80%", margin: "auto" }}>
          {
            <CreateEditRole
              type={"rolesAndRights"}
              data={currentRoleData}
              dataUI={rolesAndRightsUI}
              onChange={popUpChange}
            >
              {" "}
            </CreateEditRole>
          }
        </div>
      )}
      {popUpShow == false && (
        <div style={{ width: "50%", margin: "auto" }}>
          <h3>{t("administration.manageRolesAndRights")}</h3>
          <div className="box-name">
            {t("administration.manageRolesAndRights")}
          </div>
          <div style={{ overflow: "auto" }}>
            <table id="manageRolesAndRightsTable">
              <thead>
                <tr>
                  <th>{t("allgemein.name")}</th>
                  <th>
                    {canCreate && (
                      <button
                        className="button"
                        id="pop-up-button"
                        style={{ width: "80px" }}
                        onClick={() => editCreateRole()}
                      >
                        {t("allgemein.Neu")}
                      </button>
                    )}
                  </th>
                </tr>
              </thead>
              {rolesList()}
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default RolesList;
